/* eslint-disable @typescript-eslint/no-explicit-any */
import { storageAvailable } from "@/api/localStorage";
import { GetRequest, PostRequest } from "@/api/RequestTemplates";

const baseSubscribeUrl = "/users/newsletter";
const baseUrl = `${process.env.API_SERVER_URL}/newsletter`;
const token = "/?token=";
const getSubscribeUrl = `${baseUrl}/subscribe${token}`;
const getUnSubscribeUrl = `${baseUrl}/unsubscribe${token}`;

export async function registerForNewsletter(email: string, flags: any): Promise<any> {
  const clientId = process.env.CLIENT_ID;
  const { data } = await PostRequest(baseSubscribeUrl, { ...flags, email, clientId });
  return data;
}

export async function subscribeToNewsletter(token: string): Promise<any> {
  try {
    const actionKey = `newsletter_action_token_response_${token}`;
    if (storageAvailable() && localStorage.getItem(actionKey)) {
      return JSON.parse(localStorage.getItem(actionKey) || "{}");
    } else {
      const { data } = await GetRequest(getSubscribeUrl + token);
      if (storageAvailable()) {
        localStorage.setItem(actionKey, JSON.stringify(data));
      }
      return data;
    }
  } catch (e) {
    throw new Error("Couldn't subscribe to newsletter. " + e);
  }
}

export async function unsubscribeToNewsletter(token: string): Promise<any> {
  try {
    const { data } = await GetRequest(getUnSubscribeUrl + token);
    return data;
  } catch (e) {
    throw new Error("Couldn't unsubscribe from newsletter. " + e);
  }
}
